<template>
    <div class="flex justify-center items-center border border-gray-600 px-2 pt-2 pb-2 rounded shadow bg-gray-200 ml-1 mt-3 -mb-2 relative">
        <div class="-mt-1">
            <button class="-m-2 absolute bg-white hover:text-indigo-700 left-0 rounded-full text-indigo-500 top-0 w-5 h-5 flex items-center justify-center p-0"
                @click="closeMenu"
                :aria-label="$t('Close annotation settings')"
                ref="closeButton"
            >
                <i class="text-lg material-icons">cancel</i>
            </button>
        </div>

        <button class="text-white text-xxs uppercase px-6 py-1 rounded-sm bg-red-600 hover:bg-red-700 cursor-pointer"
            @click="deleteAnnotation"
        >
            {{ $t('Delete Entry') }}
        </button>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        annotation: null,
    },

    methods: {
        closeMenu() {
            this.$emit('clear');
        },
        deleteAnnotation() {
            axios.delete('/users/' + this.annotation.report_user_id
                + '/reportsections/' + this.annotation.report_section_id
                + '/annotations/' + this.annotation.id
            ).then(response => {
                let el = document.querySelector("[data-selection-id='" + this.annotation.render_id + "']");

                if (el) {
                    el.classList.remove('annotation-show');
                }

                this.$emit('deleteAnnotation', this.annotation.id);
            }).catch(error => {
                if (error.response.data.message) {
                    alert('Error: ' + error.response.data.message);
                }

                console.log(error.response.data);
            }).finally(() => {
                this.closeMenu();
            });
        },
    },

    mounted() {
        this.$nextTick(() => {
            this.$refs.closeButton?.focus();
        });
    },
}
</script>
